import { TitleHierarchyComponent } from '@/__configs/config_types';
import { getLineageMetaTitle } from '@/_utils/utils';
import { Typography } from '@mui/material';

const TitleHierarchy: TitleHierarchyComponent = ({ title, versionName }) => {
  return (
    <>
      <Typography variant="body1" style={{ fontWeight: 'bold' }}>
        {title.lineage_meta?.series_name}
      </Typography>
      <Typography variant="caption">{getLineageMetaTitle(title)}</Typography>
      {versionName && (
        <>
          <br />
          <Typography variant="caption" sx={{ color: '#667799' }}>
            {versionName.charAt(0).toUpperCase() + versionName.slice(1)}
          </Typography>
        </>
      )}
    </>
  );
};

export default TitleHierarchy;
